import * as React from "react";
import styled, { css } from "styled-components";
import { DropdownButton } from "components/bootstrap";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
import { IconButton } from "components/common";
import SearchForm from "components/common/SearchForm";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
export { ALPHABETICAL_SORT, defaultSortDirectionForMode } from "./slicingConstants";
import { ALPHABETICAL_SORT as ALPHABETICAL_SORT2 } from "./slicingConstants";
export const DEFAULT_SORT_OPTIONS = [{ value: ALPHABETICAL_SORT2, label: "Alphabetical" }];
const Controls = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    margin-bottom: ${theme.spacings.xs};
  `
);
const ControlsRow = styled.div(
  ({ theme, $alignRight }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    flex-wrap: nowrap;
    justify-content: ${$alignRight ? "flex-end" : "flex-start"};
  `
);
const StyledSearchForm = styled(SearchForm)`
  flex: 1;

  .query,
  .input-container,
  .form-group {
    width: 100%;
    margin: 0;
  }
`;
const SliceFilters = ({
  appSection,
  activeColumnTitle,
  sliceCol,
  searchQuery,
  onSearchQueryChange,
  onSearchReset,
  sortOptions,
  sortMode,
  onSortModeChange,
  sortDirection,
  onSortDirectionChange
}) => {
  var _a;
  const sendTelemetry = useSendTelemetry(appSection);
  const selectedSortOption = (_a = sortOptions.find((option) => option.value === sortMode)) != null ? _a : DEFAULT_SORT_OPTIONS[0];
  const handleSearchChange = (value) => {
    onSearchQueryChange(value);
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_SEARCH_CHANGED, {
      event_details: {
        attribute_id: sliceCol,
        has_query: value.length > 0
      }
    });
  };
  const handleSearchReset = () => {
    onSearchReset();
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_SEARCH_CHANGED, {
      event_details: {
        attribute_id: sliceCol,
        reset: true
      }
    });
  };
  const handleSortModeChange = (mode) => {
    if (mode === sortMode) {
      return;
    }
    onSortModeChange(mode);
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_SORT_CHANGED, {
      event_details: {
        attribute_id: sliceCol,
        sort_mode: mode
      }
    });
  };
  const handleSortDirectionChange = () => {
    const nextDirection = sortDirection === "asc" ? "desc" : "asc";
    onSortDirectionChange(nextDirection);
    sendTelemetry(TELEMETRY_EVENT_TYPE.ENTITY_DATA_TABLE.SLICE_SORT_CHANGED, {
      event_details: {
        attribute_id: sliceCol,
        sort_mode: sortMode,
        sort_direction: nextDirection
      }
    });
  };
  const sortControl = /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      bsSize: "small",
      id: "slicing-sort-dropdown",
      title: selectedSortOption.label,
      buttonTitle: `Sort by ${selectedSortOption.label}`
    },
    sortOptions.map((option) => /* @__PURE__ */ React.createElement(
      MenuItem,
      {
        key: option.value,
        onClick: () => handleSortModeChange(option.value),
        active: sortMode === option.value
      },
      option.label
    ))
  );
  return /* @__PURE__ */ React.createElement(Controls, null, /* @__PURE__ */ React.createElement(ControlsRow, null, /* @__PURE__ */ React.createElement(
    StyledSearchForm,
    {
      onQueryChange: handleSearchChange,
      onReset: handleSearchReset,
      placeholder: `Filter ${activeColumnTitle != null ? activeColumnTitle : "slices"}`,
      query: searchQuery,
      queryWidth: 0,
      buttonLeftMargin: 0
    }
  ), sortControl, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: sortDirection === "asc" ? "arrow_upward" : "arrow_downward",
      title: `Sort ${sortDirection === "asc" ? "descending" : "ascending"}`,
      onClick: handleSortDirectionChange
    }
  )));
};
export default SliceFilters;
